import { render, staticRenderFns } from "./LoyaltyStampNumber.vue?vue&type=template&id=18e38fb1&scoped=true&lang=pug&"
import script from "./LoyaltyStampNumber.vue?vue&type=script&lang=js&"
export * from "./LoyaltyStampNumber.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyStampNumber.vue?vue&type=style&index=0&id=18e38fb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e38fb1",
  null
  
)

export default component.exports